export interface RequireRule {
  required: boolean
  message?: string
}

export interface LengthRule {
  min: number
  max: number
  message?: string
}

export interface RegexRule {
  pattern: RegExp
  message?: string
}

export interface Rule<TField = string> {
  field: TField
  lengthRule?: LengthRule
  regexRule?: RegexRule
  requireRule?: RequireRule
  genericMessage?: string
}

export function createRules<TField extends string | number>(
    rules: Array<Rule<TField>>,
): Record<TField, Rule<TField>> {
  return rules.reduce<Record<TField, Rule<TField>>>((acc, rule) => {
    acc[rule.field] = rule
    return acc
  }, {} as Record<TField, Rule<TField>>)
}

export function getFirstFailedRuleMessage<TField>(
    rule: Rule<TField>,
    value: string | number | null | undefined,
): string {
  return rule.requireRule?.message || rule.lengthRule?.message || (rule.genericMessage ?? 'Invalid value')
}

export function isNullOrZero(field: any): boolean {
  if (field === null || field === undefined) {
    return true
  }
  switch (typeof field) {
    case 'boolean':
      return (field !== true)
    case 'number':
      return (field === 0)
    case 'string':
      return (field.length === 0)
    default:
      return true
  }
}

export function isNotNullOrZero(field: any): boolean {
  return !isNullOrZero(field)
}
